module.exports = __webpack_public_path__ + "media/american-coot-1.2ea49a99.mp3";